import { asyncThunkCreator, buildCreateSlice } from '@reduxjs/toolkit';

import { addAddressInfo } from '@screens/PersonalAccount/api/addAddresstInfo/addAddressInfo';
import { HttpStatuses } from '@shared/types/enums/http.enum';
import { showToast } from '@shared/utils/showToast/showToast';

import {
  addPersonalAccountInfo,
  AddPersonalAccountInfoRequestType,
  PersonalAccountAddressInfoType,
  PersonalAccountInfoStateType
} from '../../';

const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator }
});

export const initialPersonalAccountInfoState: PersonalAccountInfoStateType = {
  isLoading: false
};

export const personalAccountInfoSlice = createAppSlice({
  name: 'personalAccountInfo',
  initialState: initialPersonalAccountInfoState,
  reducers: (create) => ({
    addPersonalAccountInfoThunk: create.asyncThunk(
      async (
        {
          profileInfo,
          addressInfo
        }: { profileInfo: AddPersonalAccountInfoRequestType; addressInfo: PersonalAccountAddressInfoType },
        thunkAPI
      ) => {
        const personalAccountData = await addPersonalAccountInfo(profileInfo);
        const addressInfoData = await addAddressInfo(addressInfo);

        if (!personalAccountData.data?.ok && !addressInfoData.data?.ok) {
          return thunkAPI.rejectWithValue(HttpStatuses.ERROR);
        }

        showToast('Информация сохранена');
      },
      {
        pending: (state) => {
          state.isLoading = true;
        },
        settled: (state) => {
          state.isLoading = false;
        }
      }
    )
  })
});

export const { addPersonalAccountInfoThunk } = personalAccountInfoSlice.actions;

export const personalAccountInfoReducer = personalAccountInfoSlice.reducer;
